module.exports = __webpack_public_path__ + "img/Maggie-Lei-Chong.dddc3e85.jpg";